<div class="promotions" *ngIf="isPromociones">
  <div class="promotions__container site-content">
    <header class="promotions__header">
      <h3 class="promotions__title">
        {{ 'LANDING.PROMOTIONS.TITLE' | translate }}
      </h3>
      <p class="promotions__subtitle">
        {{ 'LANDING.PROMOTIONS.SUBTITLE' | translate }}
      </p>

      <div class="promotions__controls">
        <app-branch-select-field></app-branch-select-field>

        <div class="promotions__filters" role="tablist">
          <button
            type="button"
            class="promotions__filter-pill"
            role="tab"
            [class.promotions__filter-pill--active]="
              isCurrencySelected(allCurrenciesFilter)
            "
            [attr.aria-selected]="isCurrencySelected(allCurrenciesFilter)"
            (click)="selectCurrencyFilter(allCurrenciesFilter)"
          >
            {{ 'LANDING.PROMOTIONS.FILTER_ALL' | translate }}
          </button>

          <button
            type="button"
            class="promotions__filter-pill"
            role="tab"
            *ngFor="let currency of currencyFilters"
            [class.promotions__filter-pill--active]="
              isCurrencySelected(currency)
            "
            [attr.aria-selected]="isCurrencySelected(currency)"
            (click)="selectCurrencyFilter(currency)"
          >
            {{ currency }}
          </button>
        </div>
      </div>
    </header>
  </div>

  <div
    class="card-rail promotions__scroller"
    appCardRail
    *ngIf="promociones.length > 0"
    #promoScroller
    (scroll)="onPromoScroll($event)"
    [attr.aria-label]="'LANDING.PROMOTIONS.TITLE' | translate"
  >
    <app-promotion-card
      *ngFor="let promocion of promociones"
      [promotion]="promocion"
      (reserve)="openPromocionReserva($event)"
      (detail)="openPromocionDetail($event)"
    ></app-promotion-card>
  </div>

  <div class="site-content" *ngIf="promoDots.length > 1">
    <div
      class="promotions__dots"
      role="tablist"
      [attr.aria-label]="'LANDING.PROMOTIONS.TITLE' | translate"
    >
      <button
        type="button"
        class="promotions__dot"
        *ngFor="let i of promoDots"
        role="tab"
        [class.promotions__dot--active]="i === activePromoIndex"
        [attr.aria-selected]="i === activePromoIndex"
        [attr.aria-label]="('LANDING.PROMOTIONS.TITLE' | translate) + ' ' + (i + 1)"
        (click)="scrollToPromo(i)"
      ></button>
    </div>
  </div>
</div>
